import React from 'react'

const globalScope = typeof globalThis !== 'undefined' ? globalThis : window
const PATCH_FLAG = '__VRS_LAZY_IMG_PATCHED__'

const shouldSkipLazyProps = (props) =>
  !props || props.loading != null || props['data-lazy-exempt']

const patchReactCreateElement = () => {
  if (!React || typeof React.createElement !== 'function') {
    return
  }

  const originalCreateElement = React.createElement

  React.createElement = function patchedCreateElement(type, props, ...children) {
    let nextProps = props

    if (type === 'img' && !shouldSkipLazyProps(props)) {
      nextProps = {
        ...props,
        loading: 'lazy',
        decoding: props?.decoding ?? 'async',
      }
    }

    return originalCreateElement.call(this, type, nextProps, ...children)
  }
}

const enableLazyImageLoading = () => {
  if (globalScope[PATCH_FLAG]) {
    return
  }

  patchReactCreateElement()
  globalScope[PATCH_FLAG] = true
}

export default enableLazyImageLoading

